import { doc, updateDoc, onSnapshot, Timestamp, arrayUnion } from 'firebase/firestore';
import { getDb } from '../firebase';

export const subscribeToNotificationState = (userId, callback) => {
  const db = getDb();
  return onSnapshot(doc(db, 'users', userId), (snapshot) => {
    const data = snapshot.data();
    callback({
      lastSeenAt: data?.notificationsLastSeenAt || null,
      dismissedIds: data?.dismissedNotifications || [],
    });
  }, (error) => {
    console.error('Notifications listener error:', error);
  });
};

// Keep for backwards compatibility
export const subscribeToLastSeenAt = (userId, callback) => {
  return subscribeToNotificationState(userId, ({ lastSeenAt }) => callback(lastSeenAt));
};

export const updateLastSeenAt = async (userId) => {
  const db = getDb();
  await updateDoc(doc(db, 'users', userId), {
    notificationsLastSeenAt: Timestamp.now(),
    dismissedNotifications: [],
  });
};

export const dismissNotification = async (userId, notificationId) => {
  const db = getDb();
  await updateDoc(doc(db, 'users', userId), {
    dismissedNotifications: arrayUnion(notificationId),
  });
};
